export const useLivechatStore = () => {
    /**
     * Initializes the livechat store with visibility state
     * @public
     */
    const init = () => {
        window.Alpine.store("livechat", {
            visibility: "hidden",
        });
    };

    return { init };
};
